import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/LandingPage.css";

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("landing-page-active");
    return () => {
      document.body.classList.remove("landing-page-active");
    };
  }, []);

  const goToLogin = () => navigate("/login");

  return (
    <div className="landing">
      <div className="landing__bg" aria-hidden="true">
        <span className="landing__orb landing__orb--1" />
        <span className="landing__orb landing__orb--2" />
        <span className="landing__orb landing__orb--3" />
      </div>

      <header className="landing__nav">
        <div className="landing__brand">
          <span className="landing__brand-mark">U</span>
          <span className="landing__brand-name">UcmaApp</span>
        </div>
        <button className="landing__btn landing__btn--ghost" onClick={goToLogin}>
          Login
        </button>
      </header>

      <main className="landing__hero">
        <div className="landing__hero-copy">
          <span className="landing__badge">Fast • Secure • Everywhere</span>
          <h1 className="landing__title">
            Stay connected with the people who matter
            <span className="landing__title-accent"> — instantly.</span>
          </h1>
          <p className="landing__subtitle">
            Chat one-on-one or in groups, share moments, and jump on crystal-clear
            audio and video calls. UcmaApp keeps every conversation in sync across
            all your devices.
          </p>

          <div className="landing__cta">
            <button
              className="landing__btn landing__btn--primary"
              onClick={goToLogin}
            >
              Get Started
              <svg
                className="landing__btn-arrow"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </button>
          </div>

          <div className="landing__trust">
            <div className="landing__avatars">
              <span className="landing__avatar" />
              <span className="landing__avatar" />
              <span className="landing__avatar" />
            </div>
            <span className="landing__trust-text">
              Loved by people staying in touch every day
            </span>
          </div>
        </div>

        <div className="landing__hero-visual">
          <div className="landing__phone">
            <div className="landing__phone-top">
              <span className="landing__phone-avatar" />
              <div className="landing__phone-meta">
                <strong>Group · Friends</strong>
                <small>online</small>
              </div>
            </div>
            <div className="landing__bubbles">
              <div className="landing__bubble landing__bubble--in">
                Hey! Are we still on for tonight? 🎉
              </div>
              <div className="landing__bubble landing__bubble--out">
                Absolutely! See you at 8 ✨
              </div>
              <div className="landing__bubble landing__bubble--in">
                Sending the location now 📍
              </div>
              <div className="landing__bubble landing__bubble--out">
                Got it, see you all there! 👍
              </div>
            </div>
          </div>
        </div>
      </main>

      <section className="landing__features">
        <div className="landing__feature">
          <div className="landing__feature-icon">💬</div>
          <h3>Real-time messaging</h3>
          <p>Instant delivery with read receipts and typing indicators.</p>
        </div>
        <div className="landing__feature">
          <div className="landing__feature-icon">📞</div>
          <h3>Audio &amp; video calls</h3>
          <p>High-quality 1:1 audio &amp; video calls. Group calls are coming soon.</p>
        </div>
        <div className="landing__feature">
          <div className="landing__feature-icon">🔒</div>
          <h3>Private by design</h3>
          <p>Granular privacy controls and locked chats for peace of mind.</p>
        </div>
      </section>

      <footer className="landing__footer">
        <span>© {new Date().getFullYear()} UcmaApp. All rights reserved.</span>
      </footer>
    </div>
  );
}

export default LandingPage;
